<template>
  <div class="line-item-pricing">
    <div v-if="!giftProp">
      <span
        v-if="oldPriceProp"
        class="line-item-pricing__price line-item-pricing__price-old"
      >
        {{ formatPrice(oldPriceProp * quantityProp) }}
      </span>
      <span
        class="line-item-pricing__price"
        :class="oldPriceProp ? 'line-item-pricing__price-sale' : ''"
      >
        {{ formatPrice(priceProp * quantityProp) }}
      </span>

      <small v-if="(quantityProp || 0) > 1" class="text--small text--discrete"
        >({{ formatPrice(priceProp) }} x {{ quantityProp }})</small
      >
    </div>

    <div v-if="giftProp && !kitProp" class="line-item-pricing__gift">
      <span class="line-item-pricing__price-free">
        {{ $t('free') }}
      </span>

      <span v-if="showQuantityProp" class="line-item-pricing__qty-display">
        x{{ quantityProp }}
      </span>
    </div>
  </div>
</template>

<script>
import priceable from '~/mixins/priceable'

export default {
  mixins: [priceable],
  props: {
    kitProp: {
      type: Boolean,
      default: false,
    },
    giftProp: {
      type: Boolean,
      default: false,
    },
    oldPriceProp: {
      type: [Number, String],
      default: null,
    },
    priceProp: {
      type: [Number, String],
      default: null,
    },
    quantityProp: {
      type: [Number, String],
      default: null,
    },
    showQuantityProp: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.line-item-pricing {
  margin-top: 2px;
}
.line-item-pricing__price-old {
  text-decoration: line-through;
}

.line-item-pricing__price-sale {
  color: #f37053;
}

.line-item-pricing__gift {
  background: #f37053;
  color: #e7ef93;
  font-weight: bold;
  text-transform: uppercase;
  padding: 5px 41px 5px 10px;
  display: inline-block;
  font-size: 12px;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    width: 16px;
    height: 31px;
    display: block;
    background: #e7ef93;
    position: absolute;
    right: 15px;
    top: 0;
    transform: rotate(20deg);
  }
  &::after {
    height: 100%;
    content: '❤';
    background-color: #e7ef93;
    color: #f37053;
    width: 24px;
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    font-family: linearicons;
    speak: none;
    font-style: normal;
    font-weight: 700;
    font-variant: normal;
    text-transform: none;
    line-height: 27px;
    text-indent: 3px;
    -webkit-font-smoothing: antialiased;
  }
}

// Legacy

// .line-item__description--qty {
//   text-transform: none;
//   font-style: italic;
//   color: #999;
// }

// .line-item__description--price {
//   color: #555;

//   .line-item__description--price__old {
//     text-decoration: line-through;
//   }
//   .line-item__description--price__current {
//     color: $color;
//   }
// }

// .line-item__description--gift {
//   .line-item__description--gift-price {
//     background: #f37053;
//     color: #e7ef93;
//     font-weight: 700;
//     text-transform: uppercase;
//     padding: 5px 41px 5px 10px;
//     display: inline-block;
//     font-size: 12px;
//     position: relative;
//     overflow: hidden;

//     &::before {
//       content: '';
//       width: 16px;
//       height: 31px;
//       display: block;
//       background: #e7ef93;
//       position: absolute;
//       right: 15px;
//       top: 0;
//       transform: rotate(20deg);
//     }

//     &::after {
//       height: 100%;
//       content: '\e9ea';
//       background-color: #e7ef93;
//       color: #f37053;
//       width: 24px;
//       display: block;
//       position: absolute;
//       top: 0;
//       right: 0;
//       font-family: linearicons;
//       font-style: normal;
//       font-weight: 400;
//       font-variant: normal;
//       text-transform: none;
//       line-height: 27px;
//       text-indent: 3px;
//     }
//   }
// }
</style>
